import { createContext, useContext, useState, type ReactNode } from "react";
import type { Category, Session } from "../lib/types";

/** Normalized shape passed to the item-detail sheet (works for both menu types). */
export interface SheetItem {
  itemId: string;
  type: "standing" | "daily";
  name: string;
  nameAr: string;
  price: number;
  category?: Category;
  imageURL?: string;
  session?: Session;
  fastDelivery?: boolean;
  maxQty?: number;
  soldOut?: boolean;
  popular?: boolean;
}

interface SheetCtx {
  item: SheetItem | null;
  open: (i: SheetItem) => void;
  close: () => void;
}

const Ctx = createContext<SheetCtx | null>(null);

export function SheetProvider({ children }: { children: ReactNode }) {
  const [item, setItem] = useState<SheetItem | null>(null);
  return (
    <Ctx.Provider value={{ item, open: setItem, close: () => setItem(null) }}>
      {children}
    </Ctx.Provider>
  );
}

export function useSheet(): SheetCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useSheet must be used within SheetProvider");
  return ctx;
}
